import React from "react";
import { CiEdit } from "react-icons/ci";

const ConsumerPatientList = ({
  setPatientId,
  setIsModalOpen,
  patientsArray,
  setPatientData,
}) => {
  return (
    <>
      <div className="rounded-xl border border-1 overflow-hidden">
        <div className="max-h-[500px] overflow-y-auto">
          <table className="w-full min-w-[800px]">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr className="">
                <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                  Patient First Name
                </th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                  Patient Last Name
                </th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                  Postal code
                </th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {patientsArray?.length > 0 ? (
                patientsArray?.map((consumer, index) => (
                  <tr
                    key={consumer?.id}
                    className={` ${
                      patientsArray?.length === index + 1 ? "" : "border-b"
                    } hover:bg-gray-50`}
                  >
                    <td className="py-2 px-4">{consumer?.first_name || "-"}</td>
                    <td className="py-2 px-4">{consumer?.last_name || "-"}</td>
                    <td className="py-2 px-4">
                      {consumer?.postal_code || "-"}
                    </td>
                    <td className="py-2 px-4">
                      <button
                        className="text-blue-600 hover:text-blue-800 underline"
                        onClick={() => {
                          setPatientId(consumer?.id);
                          setIsModalOpen(true);
                          setPatientData(consumer);
                        }}
                      >
                        <CiEdit size={24} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="9"
                    className="py-4 px-4 text-center text-gray-500"
                  >
                    No data found...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ConsumerPatientList;
